var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6100_14882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6100_14882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.903969H49.152V50.056H0V0.903969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6100_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5759 37.096C24.5759 43.4583 19.4182 48.616 13.0559 48.616C6.69358 48.616 1.53589 43.4583 1.53589 37.096C1.53589 30.7337 6.69358 25.576 13.0559 25.576C19.4182 25.576 24.5759 30.7337 24.5759 37.096Z",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0559 48.616H44.7359C46.3264 48.616 47.6159 47.3265 47.6159 45.736V11.9443L38.0163 2.34397H15.9359C14.3454 2.34397 13.0559 3.63344 13.0559 5.22397V25.576",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0159 2.34397V11.944H47.6159L38.0159 2.34397Z",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6746 28.456H40.8958",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7759 19.816H40.8959",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5759 37.0959H40.8959",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0559 37.0959V31.3359",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0559 37.0959H16.8959",
    stroke: "#106C3A",
    strokeWidth: 2.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6100_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.152,
    height: 49.152,
    fill: "white",
    transform: "translate(0 0.903992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionSaved);
export default __webpack_public_path__ + "static/media/sessionSaved.0e564b93420c3ff8076d97ab6b7a36c4.svg";
export { ForwardRef as ReactComponent };